/**
 * Ícones em SVG inline — sem dependência externa, traço de 1.6 para combinar
 * com a leveza do design. Todos herdam `currentColor`.
 */

type P = { className?: string }

const S = ({ children, className }: P & { children: React.ReactNode }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className ?? 'size-4 shrink-0'}
    aria-hidden
  >
    {children}
  </svg>
)

export const IconDashboard = (p: P) => (
  <S {...p}>
    <rect x="2.5" y="2.5" width="6" height="6" rx="1.2" />
    <rect x="11.5" y="2.5" width="6" height="6" rx="1.2" />
    <rect x="2.5" y="11.5" width="6" height="6" rx="1.2" />
    <rect x="11.5" y="11.5" width="6" height="6" rx="1.2" />
  </S>
)

export const IconImport = (p: P) => (
  <S {...p}>
    <path d="M10 2.5v9m0 0 3.5-3.5M10 11.5 6.5 8" />
    <path d="M3 13v3a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 17 16v-3" />
  </S>
)

export const IconExport = (p: P) => (
  <S {...p}>
    <path d="M10 11.5v-9m0 0L6.5 6M10 2.5 13.5 6" />
    <path d="M3 13v3a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 17 16v-3" />
  </S>
)

export const IconShip = (p: P) => (
  <S {...p}>
    <path d="M3 12.5 4 8h12l1 4.5" />
    <path d="M6 8V4.5h8V8" />
    <path d="M2.5 12.5c1.8 0 1.8 1.5 3.75 1.5S8 12.5 10 12.5s1.8 1.5 3.75 1.5S15.5 12.5 17.5 12.5" />
  </S>
)

export const IconShield = (p: P) => (
  <S {...p}>
    <path d="M10 17.5s6-3 6-7.5V4.5L10 2.5 4 4.5V10c0 4.5 6 7.5 6 7.5Z" />
  </S>
)

export const IconBuilding = (p: P) => (
  <S {...p}>
    <path d="M2.5 17.5h15" />
    <path d="M4.5 17.5V5l6-2.5v15" />
    <path d="M15.5 17.5V8.5l-5-2.5" />
    <path d="M7 8h.01M7 11h.01M7 14h.01" />
  </S>
)

export const IconMoney = (p: P) => (
  <S {...p}>
    <path d="M10 2v16" />
    <path d="M14 5.5H8.75a2.75 2.75 0 0 0 0 5.5h2.5a2.75 2.75 0 0 1 0 5.5H5.5" />
  </S>
)

export const IconPlane = (p: P) => (
  <S {...p}>
    <path d="M9.5 2.5 11 8.5l6-1.5-1 2.5-4.5 2 1.5 4.5-1.5 1-2-4-2 4-1.5-1L7.5 11.5 3 9.5l-1-2.5 6 1.5 1.5-6Z" />
  </S>
)

export const IconSettings = (p: P) => (
  <S {...p}>
    <circle cx="10" cy="10" r="2.5" />
    <path d="M10 2.5v2m0 11v2m-5.3-13.2 1.4 1.4m7.8 7.8 1.4 1.4M2.5 10h2m11 0h2M4.7 15.3l1.4-1.4m7.8-7.8 1.4-1.4" />
  </S>
)

export const IconAdmin = (p: P) => (
  <S {...p}>
    <circle cx="10" cy="6.5" r="3" />
    <path d="M3.5 17.5a6.5 6.5 0 0 1 13 0" />
  </S>
)

export const IconDoc = (p: P) => (
  <S {...p}>
    <path d="M11.5 2.5H6A1.5 1.5 0 0 0 4.5 4v12A1.5 1.5 0 0 0 6 17.5h8a1.5 1.5 0 0 0 1.5-1.5V6.5l-4-4Z" />
    <path d="M11.5 2.5v4h4" />
  </S>
)

export const IconChevron = (p: P) => (
  <S {...p}>
    <path d="M7.5 4.5 13 10l-5.5 5.5" />
  </S>
)

export const IconMenu = (p: P) => (
  <S {...p}>
    <path d="M3 5.5h14M3 10h14M3 14.5h14" />
  </S>
)

export const IconSearch = (p: P) => (
  <S {...p}>
    <circle cx="9" cy="9" r="5.5" />
    <path d="M13 13l4 4" />
  </S>
)

export const IconPlus = (p: P) => (
  <S {...p}>
    <path d="M10 4v12M4 10h12" />
  </S>
)

export const IconInbox = (p: P) => (
  <S {...p}>
    <path d="M2.5 11.5h4l1 2h5l1-2h4" />
    <path d="M4.5 4.5h11l2 7v4A1.5 1.5 0 0 1 16 17H4a1.5 1.5 0 0 1-1.5-1.5v-4l2-7Z" />
  </S>
)

export const IconSparkles = (p: P) => (
  <S {...p}>
    <path d="M10 3l1.6 4.4L16 9l-4.4 1.6L10 15l-1.6-4.4L4 9l4.4-1.6L10 3Z" />
    <path d="M15.5 13.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8Z" />
  </S>
)

export const IconLogout = (p: P) => (
  <S {...p}>
    <path d="M8 17.5H4.5A1.5 1.5 0 0 1 3 16V4a1.5 1.5 0 0 1 1.5-1.5H8" />
    <path d="M13 6.5 16.5 10 13 13.5M7 10h9.5" />
  </S>
)
